import React, { useEffect, useState } from 'react';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    const timer = setInterval(() => {
      if (countdown > 0) {
        setCountdown((prevCount) => prevCount - 1);
      }
    }, 1000);

    if (countdown === 0) {
      window.location.href = '/';
    }

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <>
      <div className="flex-container justify-center" style={{ minHeight: '90vh' }}>
        <div className="flex-container direction-column justify-between outer-div">
          <div style={{ textAlign: 'center' }}>
            <MarkEmailUnreadOutlinedIcon color="primary" />
            <p
              style={{
                fontSize: 'large',
                color: 'black'
              }}>
              A confirmation email will be sent to your registered email address. Once confirmed,
              you&apos;ll also be able to view the details in your dashboard.
            </p>
            <small>
              Redirecting to &nbsp;
              <Link to="/" style={{ color: '#097EFF' }}>
                home
              </Link>
              &nbsp; in {countdown} seconds
            </small>
          </div>
        </div>
      </div>
      <style jsx>{`
        .outer-div {
          padding: 20px;
          // width: 100%;
          margin-top: 100px;
          border-radius: 5px;
        }
      `}</style>
    </>
  );
};

export default PaymentSuccess;
